::ng-deep mat-dialog-actions{margin-bottom:0!important;padding:20px!important}
/*# sourceMappingURL=corporate-tax-view-memo.component-7QUK347I.css.map */
